import { computed } from 'vue';

const DEFAULT_SOURCES = ['LOCKLINE', 'EXTERNAL', 'WIXTAR'];

export function useMemberSourceConstraints(clientMemberSystemTypeRef) {
  const availableMemberSources = computed(() => {
    const memberSystemType = clientMemberSystemTypeRef?.value;
    if (!memberSystemType) {
      return DEFAULT_SOURCES;
    }

    if (memberSystemType === 'WIXTAR') {
      return ['WIXTAR'];
    }

    return ['LOCKLINE', 'EXTERNAL'];
  });

  const isMemberSourceOptionDisabled = (source) => {
    const memberSystemType = clientMemberSystemTypeRef?.value;
    if (!memberSystemType) {
      return false;
    }
    return !availableMemberSources.value.includes(source);
  };

  const getMemberSourceDisabledTip = (source) => {
    if (!isMemberSourceOptionDisabled(source)) {
      return '';
    }

    const memberSystemType = clientMemberSystemTypeRef?.value;
    if (source === 'WIXTAR' && memberSystemType === 'LOCKLINE') {
      return '此客戶使用 LOCKLINE 會員系統，無法選擇 WIXTAR 會員';
    }

    if (memberSystemType === 'WIXTAR') {
      return '此客戶使用 Wixtar 會員系統，只能選擇 WIXTAR 會員';
    }

    return '';
  };

  const enforceMemberSourceConstraints = (memberSource, onChange) => {
    const available = availableMemberSources.value;
    if (!available.length || available.includes(memberSource)) {
      return memberSource;
    }

    const nextSource = available[0];
    if (typeof onChange === 'function') {
      onChange(nextSource);
    }
    return nextSource;
  };

  return {
    availableMemberSources,
    isMemberSourceOptionDisabled,
    getMemberSourceDisabledTip,
    enforceMemberSourceConstraints
  };
}
